var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "text-center mt-5" },
    [
      _c(
        "b-card",
        { staticClass: "mx-auto", staticStyle: { "max-width": "400px" } },
        [
          _vm.loading
            ? _c(
                "div",
                [
                  _c("b-spinner"),
                  _c("p", { staticClass: "mt-3" }, [
                    _vm._v("Vérification en cours..."),
                  ]),
                ],
                1
              )
            : _vm.error
            ? _c(
                "div",
                [
                  _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _c("h5", [_vm._v("Erreur de connexion")]),
                    _c("p", [_vm._v(_vm._s(_vm.error))]),
                  ]),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.goToLogin },
                    },
                    [_vm._v(" Retour à la page de connexion ")]
                  ),
                ],
                1
              )
            : _vm.success
            ? _c(
                "div",
                [
                  _c("b-alert", { attrs: { variant: "success", show: "" } }, [
                    _c("h5", [_vm._v("Connexion réussie !")]),
                    _c("p", [_vm._v("Redirection en cours...")]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }